/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';

const cssFix = {display: 'initial'};

export const CheckboxSize = {
    sm: "-13",
    md: "",
    lg: "-15",
}

export const Checkbox = ({id, className = undefined, label = "", selected, onChange, size = CheckboxSize.md, centered, list = false, hideMobile = false, hideDesktop = false, disabled = false}) =>

    <div className={"p-checkbox" + (size) + (centered ? " center" : "") + (list ? " list" : "") + (hideMobile ? " important-hide-mobile" : "") + (hideDesktop ? " important-hide-desktop" : "") + (disabled ? " disabled" : "")}>
        <input id={id} type="checkbox" className={className} checked={selected} onChange={onChange} disabled={disabled}/>
        <label htmlFor={id} className={"p-cursor-pointer"} style={cssFix}>
            {label}
        </label>
    </div>;
